var _path, _rect, _line, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C4.5 6.68629 7.18629 4 10.5 4H30.5C33.8137 4 36.5 6.68629 36.5 10V14H4.5V10Z",
    fill: "#FFCC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 14,
    x2: 35.5,
    y2: 14,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7492 26.22L18.4692 30.12H20.5692L23.6292 24.645C23.9292 24.12 24.1392 23.43 24.1392 22.8C24.1392 20.835 22.6092 19.38 20.6292 19.38C18.6192 19.38 17.1192 20.85 17.1192 22.8C17.1192 24.84 18.5892 26.22 20.5092 26.22H20.7492ZM20.6292 24.48C19.7292 24.48 19.0092 23.88 19.0092 22.8C19.0092 21.78 19.7292 21.12 20.6292 21.12C21.5142 21.12 22.2492 21.78 22.2492 22.8C22.2492 23.88 21.5292 24.48 20.6292 24.48Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar9);
export default __webpack_public_path__ + "static/media/calendar-9.494fec6550704d4c87aa65008e1d7531.svg";
export { ForwardRef as ReactComponent };